import type { UniclientFrame } from '@lemonade-hq/uniclient-chat';
import { useCallback, useEffect, useState } from 'react';

interface UseFreeTextInputStateProps {
  readonly currentStepFrame?: UniclientFrame;
}

interface UseFreeTextInputStateReturn {
  readonly showFreeTextInput: boolean;
  readonly setShowFreeTextInput: (show: boolean) => void;
  readonly handleClickOutside?: () => void;
}

export const useFreeTextInputState = ({
  currentStepFrame,
}: UseFreeTextInputStateProps): UseFreeTextInputStateReturn => {
  const [showFreeTextInput, setShowFreeTextInput] = useState(false);

  useEffect(() => {
    if (currentStepFrame?.freeTextInput === 'open') {
      setShowFreeTextInput(true);
    } else {
      setShowFreeTextInput(false);
    }
  }, [currentStepFrame?.freeTextInput]);

  const handleClickOutside = useCallback(() => {
    setShowFreeTextInput(false);
  }, []);

  return {
    showFreeTextInput,
    setShowFreeTextInput,
    handleClickOutside: currentStepFrame?.freeTextInput === 'toggle' ? handleClickOutside : undefined,
  };
};
